import { useQuery } from "@tanstack/react-query";

import { fetchBankingDataAggregatedTransactions } from "./api";

const BANKING_DATA_STORE_KEY = "bankingData";

export const useBankingDataAggregatedTransactions = (
  {
    resourceId,
    resourceType,
  }: {
    resourceId: number | string;
    resourceType: "GUARANTOR" | "APPLYING_COMPANY";
  },
  options = {},
) =>
  useQuery({
    queryKey: [BANKING_DATA_STORE_KEY, resourceId, resourceType],
    queryFn: async () => {
      const response = await fetchBankingDataAggregatedTransactions(
        resourceId,
        resourceType,
      );

      return response.data;
    },
    ...options,
  });
